/*global process COMMITHASH*/
import { forEach } from 'lodash'
import * as Sentry from '@sentry/browser'
import { BrowserTracing } from "@sentry/tracing"

const
  environment = process.env.NODE_ENV,
  REPORT_ERRORS = ["staging", "production"].includes(environment)

if(REPORT_ERRORS) {
  Sentry.init({
    environment,
    release: COMMITHASH,
    dsn: 'https://e8b725bbf8564097a0ac83f3fc638049@o963192.ingest.sentry.io/5911459',
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  })
}

const
  attachUserToErrorReports = ({ id, username, email }) => {
    REPORT_ERRORS && Sentry.setUser({ id, username, email })
  },

  assertAndLog = (assertion, errorMessage='An assertion failed.') => {
    if(assertion) { return }

    logException(new Error(errorMessage))
  },

  logException = (ex, errors={}) => {
    /*eslint no-console:0*/
    window.console?.error(ex, errors)

    if(!REPORT_ERRORS) { return }

    Sentry.withScope(scope => {
      // unpack extras
      forEach(errors, (value, key) => {
        scope.setExtra(key, value)
      })
      Sentry.captureException(ex)
    })
  }

export default logException
export { assertAndLog, attachUserToErrorReports, logException }
